import { supabase } from "./supabaseClient";

export const updateStrengthRatings = async () => {
  try {
    // 1. Fetch all teams
    const { data: teams, error: fetchError } = await supabase
      .from("teams")
      .select("id, price");

    if (fetchError) throw fetchError;
    if (!teams || teams.length === 0) return;

    // 2. Find min and max prices across all teams
    const prices = teams.map((t) => Number(t.price) || 10);
    const minPrice = Math.min(...prices);
    const maxPrice = Math.max(...prices);
    const priceRange = maxPrice - minPrice;

    // 3. Prepare the update objects
    const updates = teams.map((team) => {
      let normalizedRating = 50; // Default fallback rating

      // Protect against division by zero (NaN)
      if (priceRange > 0 && typeof team.price === "number") {
        normalizedRating = Math.round(
          ((team.price - minPrice) / priceRange) * 100
        );
      }

      // Ensure rating is bounded between 0 and 100 and is a valid number
      const safeRating = isNaN(normalizedRating)
        ? 50
        : Math.max(0, Math.min(100, normalizedRating));

      // Scale strength between 0.0 and 1.0 for the priceUpdater algorithm
      const safeStrength = safeRating / 100;

      return {
        id: team.id,
        rating: safeRating,
        strength: safeStrength,
      };
    });

    // 4. Update existing team records using .update() instead of .upsert()
    // This avoids triggering PostgreSQL NOT NULL constraints on non-provided columns like 'name'
    const updatePromises = updates.map((team) =>
      supabase
        .from("teams")
        .update({
          rating: team.rating,
          strength: team.strength,
        })
        .eq("id", team.id)
    );

    const results = await Promise.all(updatePromises);

    // Check if any individual update failed
    const failedUpdate = results.find((res) => res.error);
    if (failedUpdate) throw failedUpdate.error;

    console.log("Strength ratings updated successfully.");
  } catch (error) {
    console.error("Error updating strength ratings:", error);
  }
};